import * as yup from 'yup';
import { yupRequiredNonEmptyString } from '../utils/yupRequiredNonEmptyString';

export enum UploadStatus {
  Uploading = 'Uploading',
  InProgress = 'In Progress',
  Completed = 'Completed',
}

/**
 * Schema for individual upload details
 */
export const UploadDetailSchema = yup.object().shape({
  collectionID: yupRequiredNonEmptyString('Collection ID'),
  collectionDate: yupRequiredNonEmptyString('Collection date'),
  cameraID: yupRequiredNonEmptyString('Camera ID'),
  ssdID: yupRequiredNonEmptyString('SSD ID'),
  percentUploaded: yup
    .number()
    .required('Percent uploaded is required')
    .min(0, 'Percent must be at least 0')
    .max(100, 'Percent cannot exceed 100'),
  uploadStartedAt: yup.string().nullable(),
  latestFileUploadedAt: yup.string().nullable(),
  status: yup
    .string()
    .oneOf(Object.values(UploadStatus), 'Invalid upload status')
    .required('Status is required'),
});

/**
 * Schema for upload summary containing multiple upload details
 */
export const UploadSummarySchema = yup.object().shape({
  customerID: yupRequiredNonEmptyString('Customer ID'),
  customerName: yupRequiredNonEmptyString('Customer name'),
  overallPercentUploaded: yup
    .number()
    .required('Overall percent uploaded is required')
    .min(0, 'Percent must be at least 0')
    .max(100, 'Percent cannot exceed 100'),
  overallStatus: yup
    .string()
    .oneOf(Object.values(UploadStatus), 'Invalid upload status')
    .required('Overall status is required'),
  latestCollectionDate: yupRequiredNonEmptyString('Latest collection date'),
  uploads: yup
    .array()
    .of(UploadDetailSchema)
    .required('Uploads array is required'),
});

export type UploadDetail = yup.InferType<typeof UploadDetailSchema>;
export type UploadSummary = yup.InferType<typeof UploadSummarySchema>;
